
import { Component, Prop, Vue } from 'vue-property-decorator'

import TiendasYFarmaciasModel from '../models/TiendasYFarmacias'

import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EPaymentInfo,
  },
})
export default class TiendasYFarmacias extends Vue {
  @Prop({ required: true }) readonly tiendasYFarmacias!: TiendasYFarmaciasModel
}
